import styled from 'styled-components';
import { smallShadow, largeShadow } from 'ui/theme';
import { ConditionsPicker } from './conditionsPicker';
import { ContentPicker } from './contentPicker';

const Wrapper = styled.div`
  border-color: ${({ theme }) => theme.colors.gray8};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  border-style: solid;
  border-width: ${({ theme }) => theme.spacing.values.single};
  padding: ${({ theme }) => theme.spacing.values.threeEights};
  transition: box-shadow 0.25s ease-in-out;
  ${smallShadow}

  &:hover {
    ${largeShadow}
  }
`;

export const DATA_TEST = {
  block: 'clause-block',
};

export const ClauseBlock = () => {
  return (
    <Wrapper data-test={DATA_TEST.block}>
      <ConditionsPicker />
      <ContentPicker />
    </Wrapper>
  );
};
